import type { Editor } from "@tiptap/react";
import { CoreExtensionNames } from "../constants/extention";
import type { EditorRefApi } from "../types/editor";
import { getExtensionStorage } from "./get-extension-storage";
import { getParagraphCount } from "./common";

interface Args {
  editor: Editor | null;
}

export const getEditorRefHelpers = (args: Args): EditorRefApi => {
  const { editor } = args;

  return {
    blur: () => editor?.commands.blur(),
    clearEditor: (emitUpdate = false) => {
      editor?.chain().clearContent(emitUpdate).run();
    },
    getDocument: () => {
      const documentText = editor?.getText() ?? "";
      const documentHTML = editor?.getHTML() ?? "<p></p>";
      const documentJSON = editor?.getJSON() ?? null;

      return {
        text: documentText,
        html: documentHTML,
        json: documentJSON
      };
    },
    getDocumentInfo: () => ({
      characters: editor
        ? (getExtensionStorage(
            editor,
            CoreExtensionNames.CHARACTERCOUNT
          ).characters?.() ?? 0)
        : 0,
      paragraphs: getParagraphCount(editor?.state),
      words: editor
        ? (getExtensionStorage(
            editor,
            CoreExtensionNames.CHARACTERCOUNT
          ).words?.() ?? 0)
        : 0
    }),
    setEditorValue: (content, emitUpdate = false) => {
      editor?.commands.setContent(content, {
        emitUpdate,
        parseOptions: { preserveWhitespace: true }
      });
    },
    focus: (focusArgs) => editor?.commands.focus(focusArgs),
    onStateChange: (callback) => {
      editor?.on("transaction", callback);
      return () => {
        editor?.off("transaction", callback);
      };
    },
    redo: () => editor?.commands.redo(),
    undo: () => editor?.commands.undo()
  };
};
